<template>
  <c-panel caption="情報配信サービス">
    <template>
      <c-panel-content caption="メール配信">
        <span>{{promotionText}}</span>
      </c-panel-content>
    </template>

    <template #actions>
      <c-panel-action
        caption="情報配信サービスを変更する"
        :to="{ name: 'my/optins' }"
      />
    </template>
  </c-panel>
</template>

<script>
import base from './base'

export default {
  name: 'COptinsPanel',
  mixins: [
    base
  ],
  computed: {
    promotionText () {
      return this.user.optins.promotion ? '配信する' : '配信しない'
    }
  }
}
</script>
